import { Card, Group, Text, TextInput, Select } from '@mantine/core';
import { DateInput, type DateValue } from '@mantine/dates';
import { dateFormat, dateFormatUI, locale } from '@/index';
import { getFetcher } from '@/api/fetchers';
import useSWR from 'swr';
import { type Mapping } from '@/schemas/API/GET/mapping/response';
import { MappingToComboBoxItem } from '@/schemas/converters/mappingShemasConverter';
import dayjs from 'dayjs';

interface PersonInfoCardProps {
  title: string;
  disabled?: boolean;
  formContext: any;
}

export const PersonInfoCard: React.FC<PersonInfoCardProps> = props => {
  const form = props.formContext();

  const { data: sexMap } = useSWR<Mapping>('mappings/sexes', getFetcher);

  return (
    <div>
      <Card shadow="sm" padding="md" radius="md" withBorder>
        <Text fw={700} size="large">
          {props.title}
        </Text>
        <Group justify="space-between" grow className="flex items-start">
          <TextInput
            variant="filled"
            className="w-full"
            label="Titul"
            {...form.getInputProps('title')}
            disabled={props.disabled}
            onChange={e => {
              form.getInputProps('title').onChange(e);
              if (e.target.value === '') {
                form.setFieldValue('title', null);
              }
            }}
          />
          <TextInput
            variant="filled"
            className="w-full"
            label="Jméno"
            {...form.getInputProps('firstName')}
            disabled={props.disabled}
          />
          <TextInput
            variant="filled"
            className="w-full"
            label="Příjmení"
            {...form.getInputProps('lastName')}
            disabled={props.disabled}
          />
          <DateInput
            className="w-full max-w-[235px]"
            variant="filled"
            label="Datum narození"
            valueFormat={dateFormatUI}
            locale={locale}
            value={
              form.values.birthdate === ''
                ? null
                : dayjs(form.values.birthdate, dateFormat).toDate()
            }
            onChange={(d: DateValue) => {
              const date: string = dayjs(d).format(dateFormat);
              form.setFieldValue('birthdate', date);
            }}
            error={form.getInputProps('birthdate').error}
            disabled={props.disabled}
          />
          <Select
            variant="filled"
            radius="md"
            label="Pohlaví"
            data={sexMap ? MappingToComboBoxItem(sexMap) : []}
            defaultValue={sexMap?.[form.values.sex]}
            {...form.getInputProps('sex')}
            disabled={props.disabled}
            data-testid="sex-select"
          />
        </Group>
      </Card>
    </div>
  );
};
